module.exports = require('./dec/decode').BrotliDecompressBuffer;



// WEBPACK FOOTER //
// webpack:///node_modules/brotli/decompress.js